import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  getAssistantFromSameDept,
  getLightWeightPackageInfo,
  getListUserByPermission,
  getOrgConfig,
  getUserByPermission,
  getUserConfig,
} from 'services/api/admin';
import { getUserRoles } from 'services/api/department/roleWithDepartment';
import { orderedPackage } from 'services/api/pay';
import { SearchStoreListScene } from 'services/api/store';
import {
  list as getAssistantAccounts,
  ListAssistantAccountsParams,
} from 'services/api/assistant.account';

export const accounts = createQueryKeys('accounts', {
  userConfig: {
    queryKey: null,
    queryFn: ({ signal }) => getUserConfig(signal),
  },
  userByPermission: (scene: SearchStoreListScene) => ({
    queryKey: [scene],
    queryFn: ({ signal }) => getUserByPermission(scene, signal),
  }),
  listUserByPermission: (scene: 'PRODUCT_KNOWLEDGE') => ({
    queryKey: [scene],
    queryFn: ({ signal }) => getListUserByPermission(scene, signal),
  }),
  orgConfig: {
    queryKey: null,
    queryFn: ({ signal }) => getOrgConfig(signal),
  },
  /** 获取当前生效套餐 */
  orderedPackage: {
    queryKey: null,
    queryFn: ({ signal }) => orderedPackage(signal),
  },
  lightWeightPackageInfo: {
    queryKey: null,
    queryFn: ({ signal }) => getLightWeightPackageInfo(signal),
  },
  roles: {
    queryKey: null,
    queryFn: ({ signal }) => getUserRoles(signal),
  },
  assistantAccounts: (params: ListAssistantAccountsParams) => ({
    queryKey: [params],
    queryFn: ({ signal }) => getAssistantAccounts(params, signal),
  }),
  assistantFromSameDept: {
    queryKey: null,
    queryFn: ({ signal }) => getAssistantFromSameDept(signal),
  },
});
